"use client"

import { useQuery } from "@tanstack/react-query"
import type { PlanTenantCount } from "@/lib/billing/plans/plan-tenants"
import { getPlanTenantCountsAction } from "@/server-actions/billing-plan-tenants"

export function usePlanTenantCountsQuery() {
  return useQuery<Record<string, PlanTenantCount>>({
    queryKey: ["billing", "plan-tenant-counts"],
    // Tenant plan changes happen outside React Query; the global 60s staleTime would show stale counts.
    staleTime: 0,
    refetchOnMount: "always",
    queryFn: async () => {
      const result = await getPlanTenantCountsAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result.counts
    },
  })
}
